/* eslint-disable max-classes-per-file */
import { Location, MemoryHistory } from 'history';
import React from 'react';

import { MatchedRoute } from 'react-router-config';
import { Store } from 'redux';
import { MatchProps } from './components/EpisodeEditorPublish/types';
import { useT } from './i18n/hooks/useT';

type FetchDataProps = {
  history: MemoryHistory;
  match: MatchProps;
  location: Location;
  store: Store<any>;
  baseUrl: string;
  route: MatchedRoute<{
    [x: string]: string;
  }>;
};

export const withT = (
  BaseComponent: React.ComponentType & {
    fetchData?: (data: FetchDataProps) => void;
  }
) => {
  const WithTComponent = (props: any) => {
    const t = useT();
    return <BaseComponent {...props} t={t} />;
  };

  if (BaseComponent.fetchData) {
    WithTComponent.fetchData = BaseComponent.fetchData;
  }

  return WithTComponent;
};
